import axios, { AxiosResponse } from "axios";

/*
* Адрес API — одно место на всё меню. Пустая строка означает тот же origin, что у самого
* фронта: /api на бэкенд заворачивает внешний прокси, так же работает и командный api.ts.
* Для локальной разработки раскомментируйте нужную строку.
* */
export const API_HOST = "";
// export const API_HOST = "http://localhost:5004";
// export const API_HOST = "https://menu.restify.one";

export const API_URL_REST_ENDPOINT = `${API_HOST}/api/rest/menu/v1`;

const REST_REQUEST_FAILED_MESSAGE = "Запрос не выполнен";

type RestExecutionStatus = "Finished" | "Failed";

export interface RestApiResponse<T> {
    executionStatus: RestExecutionStatus;
    data: T | null;
    message?: string;
}

const buildRestUrl = (path: string) => `${API_URL_REST_ENDPOINT}${path}`;

// Гостевая поверхность анонимна: токена у гостя нет, заголовок авторизации не отправляется.
const restAxiosConfig = {
    validateStatus: () => true,
} as const;

const getFinishedData = <T>(
    response: RestApiResponse<T> | undefined
): T | null | undefined => {
    if (response?.executionStatus === "Finished") {
        return response.data ?? null;
    }

    return undefined;
};

export const restGet = async <ResponseType>(
    path: string,
    params?: Record<string, unknown>
): Promise<ResponseType | null> => {
    const result: AxiosResponse<RestApiResponse<ResponseType>> = await axios.get(
        buildRestUrl(path),
        {
            ...restAxiosConfig,
            params,
        }
    );

    return getFinishedData(result.data) ?? null;
};

export const restPost = async <ResponseType>(
    path: string,
    body?: unknown
): Promise<ResponseType | null> => {
    const result: AxiosResponse<RestApiResponse<ResponseType>> = await axios.post(
        buildRestUrl(path),
        body,
        restAxiosConfig
    );

    const data = getFinishedData(result.data);

    if (data !== undefined) {
        return data;
    }

    throw new Error(result.data?.message || REST_REQUEST_FAILED_MESSAGE);
};
